import i18n from '../../../i18n/config';
const { t } = i18n;

const suspenseFallbackMessages = {
  AddCheckList: t('fallback_messages.loading_add_checklist'),
  AddCheckListForms: t('fallback_messages.loading_add_checklist_forms'),
  AddForm: t('fallback_messages.loading_add_form'),
  AddSpiff: t('fallback_messages.loading_add_spiff'),
  Billing: t('fallback_messages.loading_billing'),
  BillingEmail: t('fallback_messages.loading_billing_email'),
  CheckListForms: t('fallback_messages.loading_checklists_forms'),
  CustomerRoute: t('fallback_messages.loading_customer'),
  DefaultMessage: t('fallback_messages.loading'),
  DocumentRoute: t('fallback_messages.loading_document'),
  EditCheckList: t('fallback_messages.loading_edit_checklist'),
  EditForm: t('fallback_messages.loading_edit_form'),
  EditNote: t('fallback_messages.loading_edit_note'),
  Equipments: t('fallback_messages.loading_equipments'),
  Assets: t('fallback_messages.loading_assets'),
  EstimateRoute: t('fallback_messages.loading_estimate'),
  GetHelpRoute: t('fallback_messages.loading_gethelp'),
  History: t('fallback_messages.loading_history'),
  InvoiceRoute: t('fallback_messages.loading_invoice'),
  Invoices: t('fallback_messages.loading_invoices'),
  JobRoute: t('fallback_messages.loading_job'),
  Main: t('fallback_messages.loading_main'),
  NoteImageView: t('fallback_messages.loading_notes_attachments'),
  Notes: t('fallback_messages.loading_notes'),
  PaymentSubmit: t('fallback_messages.loading_payment'),
  Recommendation: t('fallback_messages.loading_recommendation'),
  Deficiency: t('fallback_messages.loading_deficiency'),
  RedirectRoute: t('fallback_messages.redirecting'),
  Scheduler: t('fallback_messages.loading_scheduler'),
  ServiceAgreementRoute: t('fallback_messages.loading_sa'),
  Settings: t('fallback_messages.loading_settings'),
  SingleJobRoute: t('fallback_messages.loading_job_details'),
  TicketRoute: t('fallback_messages.loading_ticket')
};
export default suspenseFallbackMessages;
